<div class='angular-modal angular-confirm'>
    <div class="modal fade" bsModal #confirmModal="bs-modal" 
        [config]="{backdrop: 'static'}" 
        tabindex="-1" 
        role="dialog" 
        aria-hidden="true"
        (onShown)="onShown()" 
        (onHidden)="onHidden()">

        <div class="modal-dialog" style="margin-top:200px">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title pull-left"><b>{{Title}}</b></h4>
                </div>
                <div class="modal-body">

                    {{Message}}

                    <div class='angular-modal-footer'>
                        <input id='confirmCancelButton' type="button" class="btn btn-secondary modal-cancel-button" [value]="cancelButtonText">
                        <input id='confirmOkButton' type="button" class="btn btn-primary" [value]="okButtonText">
                    </div>

                </div>

            </div>
        </div>
    </div>
</div>